export default "__VITE_ASSET__fa76ab1f__"